import { Divider, Flex, Input, Select, Tooltip, Typography } from 'antd'
import { useState } from 'react'
import { Controller } from 'react-hook-form'
import { TickIcon } from 'src/assets/icons'
import SearchInputIcon from 'src/assets/images/search-input-icon.png'
import { ErrorMessage } from '@hookform/error-message'
import './index.scss'
import { handleCheckSecCodeAll } from 'src/app/shared/utils'

interface IProps {
  name: string
  placeholder: string
  options: any[]
  control: any
  errors: any
  clearErrors: any
  disabled: boolean
  defaultValue: any
  trigger: any
  isSearch?: boolean
  onChange?: any
}

const SelectWithSearch = (props: IProps) => {
  const {
    name,
    control,
    disabled,
    options,
    placeholder,
    defaultValue,
    clearErrors,
    errors,
    trigger,
    isSearch = false,
    onChange,
  } = props
  const [search, setSearch] = useState('')
  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }
  const filterOption = (input: string, option?: any) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  return (
    <Flex>
      <Controller
        name={name}
        control={control}
        disabled={disabled}
        render={({ field, fieldState }) => (
          <Flex vertical style={{ width: '100%' }}>
            <Select
              {...field}
              style={{ width: '100%' }}
              maxTagCount='responsive'
              options={options}
              status={fieldState.error ? 'error' : ''}
              placeholder={placeholder}
              mode='multiple'
              maxLength={255}
              // searchValue={search}
              defaultValue={defaultValue}
              filterOption={filterOption}
              filterSort={(a, b) => a?.label?.localeCompare(b.label)}
              showSearch={true}
              labelInValue
              autoClearSearchValue={true}
              onSelect={() => {
                setSearch('')
                trigger(name)
              }}
              onDeselect={() => {
                trigger(name)
              }}
              onChange={(value) => {
                const newValue = handleCheckSecCodeAll(value)
                onChange && onChange(newValue)
                field.onChange(newValue)
              }}
              maxTagPlaceholder={(omittedValues) => (
                <Tooltip title={omittedValues.map(({ label }) => label).join(', ')}>
                  <span>+{omittedValues?.length}</span>
                </Tooltip>
              )}
              dropdownRender={(menu) => (
                <Flex vertical style={{ width: '100%' }}>
                  <Flex style={{ padding: '4px 12px 8px', width: '100%' }}>
                    {isSearch && (
                      <Input
                        onFocus={() => clearErrors(name)}
                        onChange={onSearchChange}
                        placeholder={'Search here'}
                        prefix={<img src={SearchInputIcon} />}
                        style={{ width: '100%', height: 32 }}
                        value={search}
                      />
                    )}
                  </Flex>
                  <Divider style={{ margin: 0 }} />
                  {menu}
                </Flex>
              )}
              // optionRender={(option) => (
              //   <Flex align='center' justify='space-between'>
              //     <Typography>{option.label}</Typography>
              //     {!field?.value.includes(option.value) && <TickIcon />}
              //   </Flex>
              // )}
            ></Select>
            {fieldState.error && (
              <Typography className='error-message'>
                <ErrorMessage errors={errors} name={name} />
              </Typography>
            )}
          </Flex>
        )}
      />
    </Flex>
  )
}

export default SelectWithSearch
